const mixins = {
    methods: {
        reload(timeout = 0) {
            setTimeout(() => location.reload(), timeout);
        },

        redirect(name, params = {}, timeout = 0) {
            setTimeout(() => location.href = route(name, params), timeout);
        },

        redirectToLink(link, timeout = 0) {
            setTimeout(() => location.href = link, timeout);
        },

        confirm(title, text, icon = 'question', buttons = null) {
            buttons = buttons || {confirm: "Yes", cancel: "No"};

            return this.$swal({
                icon, title, text,
                confirmButtonText: buttons.confirm,
                cancelButtonText: buttons.cancel,
                showCancelButton: true,
            });
        },

        promptSwal(icon, text, title) {
            if (typeof text === "object") {
                title = text.title
                text = text.message
            }
            return this.$swal({
                icon, title, text,
                confirmButtonText: 'Okay',
            });
        },

        promptInfo(message, title) {
            return this.promptSwal("info", message, title);
        },

        promptSuccess(message, title = "Success") {
            return this.promptSwal("success", message, title);
        },

        presentError(error, message = null) {
            if (window.debug_log_enabled === true || window.debug_log_enabled === "true") {
                console.error(error);
            }

            this.promptErrors(message || error.response.data.message);
        },

        promptFormErrors(refs, error, debug = false) {
            if (debug) {
                console.log(error);
            }
            const { response } = error;
            this.promptErrors(response.data.message);
            if (!response.data.errors) {
                return;
            }

            for (const key in response.data.errors) {
                if (!response.data.errors.hasOwnProperty(key)) {
                    return;
                }
                if (!refs[key]) continue;

                const messages = Array.isArray(response.data.errors[key])
                    ? response.data.errors[key].map(message => message.replaceAll("_", " "))
                    : response.data.errors[key].replaceAll("_", " ");
                if (Array.isArray(refs[key])) {
                    refs[key][0].error = messages;
                } else {
                    refs[key].error = messages;
                }
            }


        },

        promptMessage(title, text, icon = "success", allowOutsideClick = false, options = {}) {
            return this.$swal({
                icon, title, text, allowOutsideClick,
                confirmButtonText: options.confirmButtonText || 'Okay',
                ...options
            });
        },

        promptErrors(message, title = "Something went wrong") {
            if (typeof message === "object") {
                title = message.title
                message = message.message
            }
            this.$swal({
                icon: 'error',
                title, text: message,
                confirmButtonText: 'Okay',
            });
        },

        refreshOrRedirect(title, text, route, icon = "", button = null) {
            button = button || { confirm: 'Yes', cancel: 'No' };
            return this.$swal({
                    icon, title, text,
                    showCancelButton: true,
                    confirmButtonText: button.confirm,
                    cancelButtonText: button.cancel,
                    allowOutsideClick: false,
                })
                .then(response => response.value ? this.reload() : this.redirectToLink(route));
        },

        pad(num, size) {
            var s = num+"";
            while (s.length < size) s = "0" + s;
            return s;
        },

        formatDuration(duration) {
            duration = moment.duration(duration, "minutes");
            let minutes = duration.minutes();
            let hours = duration.hours();
            minutes = minutes > 0
                ? (minutes == 1 ? `${ minutes } mn` : `${ minutes } mns`)
                : ""
            hours = hours > 0
                ? (hours == 1 ? `${ hours } hr` : `${ hours } hrs`)
                : ""

            return `${ minutes } ${ hours }`.trim()
        },

        
        initializeTooltip(selector, label, placement="left") {
            $(selector).tooltip({
                tooltipClass: "tooltip-badge",
                boundary: "window",
                title: label,
                content: label,
                placement: placement,
            });
        },

        initTooltip(selector = '.tooltiped') {
            $(selector).each(function() {
                $(this).tooltip({
                    tooltipClass: "tooltip-badge",
                    boundary: "window",
                    title: $(this).data('title'),
                    content: $(this).data('title'),
                    placement: 'left',
                })
            });
        },
        formatOptions(options, delimiter = "-") {
            return options.map((option, key) => {
                let text = option.replaceAll(delimiter, " ");

                return {
                    value: Number.isInteger(key) ? option : key,
                    text: text.charAt(0).toUpperCase() + text.slice(1),
                };
            });
        }
    }
};

export default mixins;
export { mixins };
